<template>
  <div class="pages">
    <el-row :gutter="50">
      <template v-for="(val, idx) in dataList">
        <el-col :span="$store.state.userinfo.isSuper?6:8" :key="idx" class="backimg" :class="'backimg' + idx" v-if="!(idx===0&&!$store.state.userinfo.isSuper)">
          <div class="justify-center section" :class="'back' + idx">
            <div class="flex-row group_8">
              <span class="text_9">{{ val.name }}</span>
              <img
                v-if="val.state"
                src="../assets/images/up.png"
                class="image_6 image_8"
              />
              <img
                v-if="!val.state"
                src="../assets/images/down.png"
                class="image_6 image_8"
              />
            </div>
            <span class="text_10">{{ val.number }}</span>
          </div>
        </el-col>
      </template>
    </el-row>
    <el-row class="register" :gutter="26">
      <el-col :span="10">
        <el-card class="box-card user-card" v-if="$store.state.userinfo.isSuper">
          <span class="title">新用户注册量</span>
          <el-row :gutter="10">
            <el-col :span="12">
              <el-tabs v-model="register" @tab-click="handleClick">
                <el-tab-pane label="今日" name="1"></el-tab-pane>
                <el-tab-pane label="昨日" name="2"></el-tab-pane>
                <el-tab-pane label="本周" name="3"></el-tab-pane>
                <el-tab-pane label="本月" name="4"></el-tab-pane>
              </el-tabs>
              <div class="data registerFlex">
                <img class="avaImg" src="../assets/images/avaimg.png" alt=""/>
                <div class="userCount">
                  <b>{{ addUserInfo.userCount }}</b>
                  <span>注册用户/人</span>
                </div>
              </div>
            </el-col>
            <el-col :span="10">
              <el-date-picker
                style="width: 100%"
                v-model="registerTime"
                @change="dateChange"
                type="daterange"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                value-format="yyyy-MM-dd"
              >
              </el-date-picker>
              <div class="data">
                <div style="white-space: nowrap; margin-top: 20px">
                  <span style="margin-right: 30px"
                  ><i class="iconTitle">男：</i
                  >{{ addUserInfo.maleCount }}人</span
                  >
                  <b class="number">{{ addUserInfo.malePercent }}</b>
                  <span>较昨日提升了{{ addUserInfo.maleUpPercent }}</span>
                  <img
                    v-if="addUserInfo.isUpMale"
                    src="../assets/images/up2.png"
                    alt=""
                  />
                  <img
                    v-if="!addUserInfo.isUpMale"
                    src="../assets/images/down2.png"
                    alt=""
                  />
                  <!-- <span class="number2">{{ addUserInfo.maleUpPercent }}</span> -->
                </div>
                <div style="white-space: nowrap">
                  <span style="margin-right: 30px"
                  ><i class="iconTitle">女：</i
                  >{{ addUserInfo.femaleCount }}人</span
                  >
                  <b class="number">{{ addUserInfo.femalePercent }}</b>
                  <span>较昨日提升了{{ addUserInfo.femaleUpPercent }}</span>
                  <img
                    v-if="addUserInfo.isUpFemale"
                    src="../assets/images/up2.png"
                    alt=""
                  />
                  <img
                    v-if="!addUserInfo.isUpFemale"
                    src="../assets/images/down2.png"
                    alt=""
                  />
                  <!-- <span class="number2">{{ addUserInfo.femaleUpPercent }}</span> -->
                </div>
                <div style="white-space: nowrap">
                  <span style="margin-right: 30px">
                    <i class="iconTitle">未知：</i
                    >{{ addUserInfo.unknownCount }}人</span
                  >
                  <b class="number">{{ addUserInfo.unknownPercent }}</b>
                  <!-- <span class="number2">{{ addUserInfo.femaleUpPercent }}</span> -->
                </div>
              </div>
            </el-col>
          </el-row>
        </el-card>
      </el-col>
      <el-col :span="$store.state.userinfo.isSuper?7:12">
        <el-card class="box-card">
          <span class="title">认证统计</span>
          <el-tabs
            class="mini tabsRight"
            v-model="authentication"
            @tab-click="handleClick2"
          >
            <el-tab-pane label="本周" name="1"></el-tab-pane>
            <el-tab-pane label="本月" name="2"></el-tab-pane>
            <el-tab-pane label="本年" name="3"></el-tab-pane>
          </el-tabs>
          <div
            id="rz"
            style="width: 90%; margin: 0 auto; height: 1.99rem"
          ></div>
        </el-card>
      </el-col>
      <el-col :span="$store.state.userinfo.isSuper?7:12">
        <el-card class="box-card">
          <span class="title">平均/天使用时长</span>
          <el-tabs
            class="mini tabsRight"
            v-model="useTime"
            @tab-click="handleClick"
          >
            <el-tab-pane label="" name="0"></el-tab-pane>
            <el-tab-pane label="" name="1"></el-tab-pane>
            <el-tab-pane label="" name="2"></el-tab-pane>
          </el-tabs>
          <div id="time" style="width: 100%; height: 1.92rem"></div>
        </el-card>
      </el-col>
    </el-row>
    <el-row style="margin-top: 0.25rem">
      <el-card class="box-card">
        <el-row>
          <el-col :span="6">
            <span class="title">用户数量统计</span>
            <div
              id="userNumber"
              style="width: 100%; height: 3rem; margin-left: -50px"
            ></div>
          </el-col>
          <el-col :span="6">
            <span class="title">认证用户角色统计</span>
            <div
              id="userRole"
              style="width: 100%; height: 3rem; margin-left: -50px"
            ></div>
          </el-col>
          <el-col :span="6">
            <span class="title">用户年龄统计环形图</span>
            <div
              id="userAge"
              style="width: 100%; height: 3rem; margin-left: -50px"
            ></div>
          </el-col>
          <el-col :span="6">
            <span class="title">用户周活跃度统计</span>
            <div
              id="userActive"
              style="width: 100%; height: 3rem; margin-left: -50px"
            ></div>
          </el-col>
        </el-row>
      </el-card>
    </el-row>
    <el-row style="margin-top: 0.25rem" class="register" :gutter="25">
      <el-col :span="9">
        <el-card class="box-card">
          <span class="title">工作领域</span>
          <div class="workList">
            <template v-for="(val, idx) in homeDataWorkFieldCount">
              <div class="work" :key="idx">
                <div class="flex justify-between">
                  <span>{{ val.name }}</span>
                  <span>{{ val.value }}</span>
                </div>
                <el-slider
                  disabled
                  class="noMove"
                  v-model="val.value"
                  :max="maxValue"
                  height="10px"
                ></el-slider>
              </div>
            </template>
          </div>
        </el-card>
      </el-col>
      <el-col :span="15">
        <el-card class="box-card">
          <span class="title">内容发布量趋势</span>
          <div id="contentRelease" style="width: 100%; height: 5.5rem"></div>
        </el-card>
      </el-col>
    </el-row>
  </div>
</template>
<script>
import {
  staticEchartsInit,
  useEchartsInit,
  userEchartsInit,
  userEchartsInit2,
  userEchartsInit3,
  userEchartsInit4,
  publishEchartsInit,
} from "./echartsInit.js";

export default {
  data() {
    return {
      value: 100,
      maxValue: 1000,
      // 首页top循环
      dataList: [
        {
          name: "新增用户数",
          number: "",
          state: true,
        },
        {
          name: "日活用户量",
          number: "",
          state: false,
        },
        {
          name: "新增内容量",
          number: "",
          state: true,
        },
        {
          name: "意见反馈量",
          number: "",
          state: false,
        },
      ],
      register: "1", //注册量tabs
      registerTime: [], //注册量时间
      authentication: "1", //认证统计tabs
      useTime: 0, //平均使用时间tabs
      workList: [
        {name: "在校生", value: 343},
        {name: "计算机/互联网/通信/电子", value: 153},
        {name: "销售/客服", value: 563},
        {name: "会计/金融/银行/保险", value: 253},
        {name: "生产/营运/采购/物流", value: 843},
        {name: "人事/行政/高级管理", value: 535},
        {name: "建筑/房地产", value: 32},
        {name: "教育/培训", value: 456},
        {name: "设计/市场/媒体/广告", value: 459},
        {name: "生物/制药/化工/医疗", value: 138},
        {name: "咨询/法律/科研", value: 354},
        {name: "服务业", value: 52},
        {name: "政府机构/翻译/其他", value: 552},
      ],
      //新增新户信息
      addUserInfo: {},
      //日活用户了
      dayActiveInfo: {},
      //新增内容量
      dataAddArticle: {},
      //意见反馈
      dataFeedback: {},
      //认证统计
      dataAttestation: {},
      //统计图表
      staticEchartValue: [],
      //未认证
      staticEchartValue2: [],
      staticEchartName: [],
      //使用图表
      useEchartValue: [],
      useEchartName: [],
      //使用时长
      useTimeData: [],
      //用户角色统计
      attestationUserCount: {},
      //工作领域统计
      homeDataWorkFieldCount: {},
      //用户年龄统计
      homeDataAgeCount: {},
      //周活跃统计
      homeDataWeekActive: {},
      //内容发布
      homeDataArticleCount: {},
      homeDataArticleName: [],
      homeDataArticleValue: [],
    };
  },
  async created() {
    await this.getHomeDataAddUser(1);
    await this.getHomeDataDayActive();
    await this.getDataAddArticle();
    await this.getHomeDataFeedback();
    await this.getHomeDataAttestation();
    await this.getHomeDataDayUseTime();
    await this.getHomeDataAttestationUserCount();
    await this.getHomeDataAgeCount();
    await this.getHomeDataWorkFieldCount();
    await this.getHomeDataWeekActive();
    await this.getHomeDataArticleCount();
  },
  methods: {
    handleClick() {
      this.registerTime = [];
      this.getHomeDataAddUser();
    },
    handleClick2() {
      this.getHomeDataAttestation();
    },
    dateChange() {
      this.register = 0;
      this.getHomeDataAddUser();
    },
    //获取首页用户新增
    getHomeDataAddUser() {
      var query = {
        type: this.register,
        starttime: this.registerTime == null ? "" : this.registerTime[0],
        endtime: this.registerTime == null ? "" : this.registerTime[1],
      };
      var url = this.$dataConver.getUrl(
        "/admin/Home/GetHomeDataAddUser",
        query
      );
      this.$api.get(url).then((res) => {
        if (res.succeed) {
          this.addUserInfo = res.data;
          if (this.register == 1) {
            this.dataList[0].number = this.addUserInfo.userCount;
            this.dataList[0].state = this.addUserInfo.isUp;
          }
        } else {
          this.$message.error(res.error);
        }
      });
    },
    //获取首页用户新增
    getHomeDataDayActive() {
      this.$api.get("/admin/Home/GetHomeDataDayActive").then((res) => {
        if (res.succeed) {
          this.dayActiveInfo = res.data;
          this.dataList[1].number = this.dayActiveInfo.activeCount;
          this.dataList[1].state = this.dayActiveInfo.isUp;
        } else {
          this.$message.error(res.error);
        }
      });
    },
    //获取首页用户新增
    getDataAddArticle() {
      this.$api.get("/admin/Home/GetHomeDataAddArticle").then((res) => {
        if (res.succeed) {
          this.dataAddArticle = res.data;
          this.dataList[2].number = this.dataAddArticle.articleCount;
          this.dataList[2].state = this.dataAddArticle.isUp;
        } else {
          this.$message.error(res.error);
        }
      });
    },
    //获取首页意见反馈
    getHomeDataFeedback() {
      this.$api.get("/admin/Home/GetHomeDataFeedback").then((res) => {
        if (res.succeed) {
          this.dataFeedback = res.data;
          this.dataList[3].number = this.dataFeedback.feedbackCount;
          this.dataList[3].state = this.dataFeedback.isUp;
        } else {
          this.$message.error(res.error);
        }
      });
    },
    //获取认证统计
    getHomeDataAttestation() {
      var query = {
        type: this.authentication,
      };
      var url = this.$dataConver.getUrl(
        "/admin/Home/GetHomeDataAttestation",
        query
      );
      this.$api.get(url).then((res) => {
        if (res.succeed) {
          this.staticEchartValue = [];
          this.staticEchartValue2 = [];
          this.staticEchartName = [];
          this.dataAttestation = res.data;
          console.log(this.dataAttestation);
          this.dataAttestation.attestation.forEach((element) => {
            this.staticEchartValue.push(element.value);
            this.staticEchartName.push(element.name);
          });
          this.dataAttestation.noAttestation.forEach((element) => {
            this.staticEchartValue2.push(element.value);
          });

          setTimeout(() => {
            staticEchartsInit(
              this.staticEchartName,
              this.staticEchartValue,
              this.staticEchartValue2
            );
          }, 20);
        } else {
          this.$message.error(res.error);
        }
      });
    },
    //获取评价使用时长
    getHomeDataDayUseTime() {
      var query = {
        type: this.authentication,
      };
      var url = this.$dataConver.getUrl(
        "/admin/Home/GetHomeDataDayUseTime",
        query
      );
      this.$api.get(url).then((res) => {
        if (res.succeed) {
          this.useEchartValue = [];
          this.useEchartName = [];
          this.useTimeData = res.data;
          this.useTimeData.forEach((element) => {
            this.useEchartValue.push(element.value);
            this.useEchartName.push(element.name);
          });
          setTimeout(() => {
            useEchartsInit(this.useEchartName, this.useEchartValue);
          }, 20);
        } else {
          this.$message.error(res.error);
        }
      });
    },
    //获取角色统计
    getHomeDataAttestationUserCount() {
      this.$api
        .get("/admin/Home/GetHomeDataAttestationUserCount")
        .then((res) => {
          if (res.succeed) {
            this.attestationUserCount = res.data;
            console.log(this.attestationUserCount);
            userEchartsInit(this.attestationUserCount.attestation);
            userEchartsInit2(this.attestationUserCount.attestationRole);
          } else {
            this.$message.error(res.error);
          }
        });
    },
    //获取工作领域
    getHomeDataWorkFieldCount() {
      this.$api.get("/admin/Home/GetHomeDataWorkFieldCount").then((res) => {
        if (res.succeed) {
          res.data.forEach(v => {
            if (this.maxValue < v.value) {
              this.maxValue = v.value
            }
          })
          this.homeDataWorkFieldCount = res.data;
        } else {
          this.$message.error(res.error);
        }
      });
    },
    //获取用户年龄统计
    getHomeDataAgeCount() {
      this.$api.get("/admin/Home/GetHomeDataAgeCount").then((res) => {
        if (res.succeed) {
          this.homeDataAgeCount = res.data;
          userEchartsInit3(this.homeDataAgeCount);
        } else {
          this.$message.error(res.error);
        }
      });
    },
    //获取周活跃统计
    getHomeDataWeekActive() {
      this.$api.get("/admin/Home/GetHomeDataWeekActive").then((res) => {
        if (res.succeed) {
          this.homeDataWeekActive = res.data;
          userEchartsInit4(this.homeDataWeekActive);
        } else {
          this.$message.error(res.error);
        }
      });
    },
    //获取内容发布量
    getHomeDataArticleCount() {
      this.$api.get("/admin/Home/GetHomeDataArticleCount").then((res) => {
        if (res.succeed) {
          this.homeDataArticleName = [];
          this.homeDataArticleValue = [];
          this.homeDataArticleCount = res.data;
          this.homeDataArticleCount.forEach((element) => {
            this.homeDataArticleName.push(element.name);
            this.homeDataArticleValue.push(element.value);
          });
          publishEchartsInit(
            this.homeDataArticleName,
            this.homeDataArticleValue
          );
        } else {
          this.$message.error(res.error);
        }
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.iconTitle {
  display: inline-block;
  width: 0.45rem;
  text-align: right;
  font-size: 0.16rem;
  color: #333;
}

.user-card > > > .el-card__body {
  padding-bottom: 36px !important;
}

.registerFlex {
  display: flex;
  align-items: center;
}

.userCount {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.register {
  .data {
    padding: 0.2rem 0;

    .avaImg {
      width: 0.82rem;
      height: 0.82rem;
    }

    span {
      color: #333333;
      font-size: 0.16rem;
      display: inline-block;
      // min-width: 0.3rem;
      white-space: nowrap;
    }

    b {
      color: #333333;
      font-size: 0.6rem;
    }

    img {
      // width: 0.21rem;
      // height: 0.32rem;
      vertical-align: middle;
    }

    .number {
      color: #2e9bff;
      font-size: 0.24rem;
    }

    .number2 {
      margin-left: 0.07rem;
      margin-top: 0.14rem;
      color: #2e9bff;
      font-size: 0.3rem;
    }

    div:nth-child(2) {
      .number,
      .number2 {
        color: #fb8994;
      }
    }
  }
}

.section {
  padding: 0.45rem;
  border-radius: 0.04rem;

  .group_8 {
    line-height: 0.3rem;
    padding: 0.05rem 0;

    .text_9 {
      margin-top: 0.02rem;
      font-size: 0.3rem;
      color: #fff;
    }

    .image_6 {
      flex-shrink: 0;
      width: 0.21rem;
      height: 0.32rem;
    }

    .image_8 {
      margin-left: 0.05rem;
    }
  }

  .text_10 {
    margin-left: 0.23rem;
    color: rgb(255, 255, 255);
    font-size: 0.48rem;
    font-family: Microsoft YaHei;
    font-weight: 700;
    line-height: 0.4rem;
  }
}

.back0 {
  background-image: linear-gradient(
      135deg,
      rgb(255, 139, 135) 0%,
      rgb(247, 192, 149) 100%
  );
}

.back1 {
  background-image: linear-gradient(
      135deg,
      rgb(66, 220, 197) 0%,
      rgb(9, 195, 159) 100%
  );
}

.back2 {
  background-image: linear-gradient(
      135deg,
      rgb(52, 214, 255) 0%,
      rgb(53, 158, 252) 100%
  );
}

.back3 {
  background-image: linear-gradient(
      135deg,
      rgb(74, 165, 253) 0%,
      rgb(73, 112, 254) 100%
  );
}

.backimg0 {
  background-image: url("../assets/images/backimg0.png");
}

.backimg1 {
  background-image: url("../assets/images/backimg1.png");
}

.backimg2 {
  background-image: url("../assets/images/backimg2.png");
}

.backimg3 {
  background-image: url("../assets/images/backimg3.png");
}

.backimg {
  background-repeat: no-repeat;
  padding-bottom: 38px;
  background-size: 90% 100%;
  background-position: bottom;
}

> > > {
  .el-tabs__nav-wrap::after {
    display: none;
  }

  .el-date-editor--timerange.el-input__inner {
    width: 100%;
  }
}

.work {
  width: 75%;
  margin: 0.092rem auto 0;

  span {
    font-size: 14px;
    color: #282828;
  }
}

.workList {
  .work:nth-child(1) > > > .el-slider__bar {
    background: #ff5757;
  }

  .work:nth-child(2) > > > .el-slider__bar {
    background: #ff7723;
  }

  .work:nth-child(3) > > > .el-slider__bar {
    background: #eade20;
  }

  .work:nth-child(4) > > > .el-slider__bar {
    background: #b8da88;
  }

  .work:nth-child(5) > > > .el-slider__bar {
    background: #15b062;
  }

  .work:nth-child(6) > > > .el-slider__bar {
    background: #4ea7ec;
  }

  .work:nth-child(7) > > > .el-slider__bar {
    background: #32169a;
  }

  .work:nth-child(8) > > > .el-slider__bar {
    background: #b316c0;
  }

  .work:nth-child(9) > > > .el-slider__bar {
    background: #ec4887;
  }

  .work:nth-child(10) > > > .el-slider__bar {
    background: #2f3a4c;
  }

  .work:nth-child(11) > > > .el-slider__bar {
    background: #f1d59a;
  }

  .work:nth-child(12) > > > .el-slider__bar {
    background: #4ea7ec;
  }

  .work:nth-child(13) > > > .el-slider__bar {
    background: #dbb3d5;
  }
}

//表单伪元素
#userAge::after,
#userRole::after,
#userNumber::after {
  top: 35px;
  right: 0;
  display: inline-block;
  content: "";
  width: 2px;
  height: 170px;
  background-color: #ccc;
  position: absolute;
}
</style>



// WEBPACK FOOTER //
// src/view/index.vue